import React from 'react';
import PropTypes from 'prop-types';
import {Route, Switch, Redirect, withRouter} from 'react-router';
import {connectToStores} from 'epic-alt-utils/index';
import {generateRoutePath} from 'epic-common/src/route';
import queryString from 'query-string';
import {MobileStore, LoginStore, HeaderStore, AppConfigStore} from '../../stores';
import LoadScreen from '../../components/loadScreen/LoadScreen';
import CreateSignUp from '../../components/mobile/CreateSignUp';
import CreateDeviceSelect from '../../components/mobile/CreateDeviceSelect';
import CreateConfirmPage from '../../components/mobile/CreateConfirmPage';
import IosGameConfirm from '../../components/mobile/IosGameConfirm';
import AndroidView from './AndroidView';
import root from 'window-or-global';

@connectToStores
class MobileView extends React.Component {
    static propTypes = {
        mobileStore: PropTypes.object,
        appConfigStore: PropTypes.object,
        loginStore: PropTypes.object,
        location: PropTypes.object,
        mobile: PropTypes.bool,
        tablet: PropTypes.bool,
        match: PropTypes.object,
        bowser: PropTypes.object
    };

    static getStores() {
        return [MobileStore, HeaderStore, AppConfigStore];
    }

    static getPropsFromStores() {
        return {
            mobileStore: MobileStore.getState(),
            loginStore: LoginStore.getState(),
            appConfigStore: AppConfigStore.getState(),
            mobile: HeaderStore.getState().mobile(),
            tablet: HeaderStore.getState().tablet(),
            bowser: HeaderStore.getState().bowser()
        };
    }

    generateAndroidLink = () => {
        const {androidDownloadUrl, epicSid} = this.props.appConfigStore;
        let link = androidDownloadUrl;
        const DNT = typeof root.navigator.doNotTrack === 'undefined' ? root.doNotTrack : root.navigator.doNotTrack;
        if (epicSid && DNT !== 1 && DNT !== '1') {
            // if DNT is OFF
            link = `${androidDownloadUrl}?id=${epicSid}`
        }

        return link;
    }
    render() {
        const {mobileStore, mobile, tablet, bowser, appConfigStore = {}} = this.props;
        if (!appConfigStore.isGameLaunched) {
            return <Redirect to={generateRoutePath('/page-not-found')} />;
        }
        const location = this.props.location || {};
        const {androidMobileData, androidDownloadData, mobileData, mode, status, platformSelected, platform} = mobileStore;
        const {loading: appConfigLoading} = appConfigStore;
        if (appConfigLoading) return <LoadScreen />;
        const androidLink = this.generateAndroidLink();
        const isLoggedIn = true; // no login check
        const search = location.search || '';
        const query = queryString.parse(search) || {};
        const data = mobileData || {};
        const code = query.code && typeof query.code === 'string' ? query.code.replace(/-/g, '').substring(0, 20) : undefined;
        const {locale} = this.props.match.params;
        const isFromApp = !!(mode === 'iosgame');
        query.code = code;
        query.mode = query.mode || undefined;
        let redirect = generateRoutePath(`/mobile/download?${queryString.stringify(query)}`);

        const isAndroid = bowser.android;
        const isIos = bowser.ios;
        if (isAndroid) redirect = generateRoutePath('/mobile/android');
        if (isIos) redirect = generateRoutePath('/mobile/ios');
        const {googlePlayCountries: countries='', googlePlayIcon, country} = appConfigStore;
        const googlePlayCountries = countries ? countries.split(',').map(i => i.trim()) : [];
        const shouldShowGooglePlayStore = googlePlayCountries.includes(country);
        return (
            <div className="mobile-view">
                <Switch>
                    <Route key="create-account" path="/:path/:locale/mobile/download">
                        <CreateSignUp
                            title={data.title}
                            isLoggedIn={isLoggedIn}
                            content={data.signup}
                            mobile={mobile}
                            tablet={tablet}
                            location={location}
                            isGame={isFromApp}
                            status={status}
                        />
                    </Route>
                    <Route key="device-select" path="/:path/:locale/mobile/account-device-select">
                        <CreateDeviceSelect content={data.device} isLoggedIn={isLoggedIn} status={status} title={data.title} />
                    </Route>
                    <Route key="account-confirm" path="/:path/:locale/mobile/ios">
                        <CreateConfirmPage
                            content={data.confirm}
                            isLoggedIn={isLoggedIn}
                            downloadContent={data.codeConfirm}
                            updateMessage={platformSelected}
                            platform={platform}
                            title={data.title}
                            isGame={isFromApp}
                        />
                    </Route>
                    <Route key="ios-confirm" path="/:path/:locale/mobile/iosgame-confirm">
                        <IosGameConfirm content={data.confirm} isLoggedIn={isLoggedIn} title={data.title} />
                    </Route>
                    <Route path="/:path/:locale/mobile/ios">
                        <Redirect to={generateRoutePath(`/download${search}`)} />
                    </Route>
                    <Route path="/:path/:locale/mobile/android">
                        <AndroidView
                            downloadData={androidDownloadData}
                            cmsData={androidMobileData}
                            isLoggedIn={isLoggedIn}
                            mobile={mobile}
                            tablet={tablet}
                            status={status}
                            locale={locale}
                            code={code}
                            androidLink={androidLink}
                            bowser={bowser}
                            shouldShowGooglePlayStore={shouldShowGooglePlayStore}
                            googlePlayIcon={googlePlayIcon}
                        />
                    </Route>
                    <Route path="/:path/:locale/mobile">
                        <Redirect to={redirect} />
                    </Route>
                </Switch>
                <LoadScreen show={mobileStore.loading} />
            </div>
        );
    }
}

export default withRouter(MobileView);
